import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { formValidation } from 'utils/validation';
import { MIN_ZIP_LENGTH, ZIP_MASK_OPTIONS } from './config';

export const validateZip = (value: string) => formValidation.zip(value, MIN_ZIP_LENGTH);

type Props = Pick<
  RootInputProps,
  | 'name'
  | 'label'
  | 'required'
  | 'placeholder'
  | 'containerClassName'
  | 'rules'
  | 'externalOnChange'
>;

const ZipInput = (props: Props) => {
  const { name, label, required, placeholder, containerClassName, rules, externalOnChange } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      control={control}
      clearErrors={clearErrors}
      name={name}
      label={label}
      required={required}
      placeholder={placeholder}
      autoComplete={uuidv4()}
      maskOptions={ZIP_MASK_OPTIONS}
      containerClassName={containerClassName}
      rules={rules}
      externalOnChange={externalOnChange}
      inputMode="numeric"
      spellCheck={false}
    />
  );
};

export default ZipInput;
